import { formatDecimal, formatVolume } from "utils";
import { formatAmount, formatPumpNumber } from "utils/text.utils";
import { Text } from "components/commons";
import styles from "../cash-noncash.module.scss";

export const cashTransactionMapper = ({ val, transactionsItemDetails = [] }) => {
  let {
    type,
    name,
    pumpNumber,
    quantity,
    totalAmount,
    finalAmount,
    vatAmount,
    // amountPaid,
    discount,

    // Values from enriched data for formula calculation
    // productAmount,
    // productDiscount,
    // transactionTotalAmount,
    // paymentMethodAmount,
  } = val;

  discount = discount + vatAmount;
  const hasDiscount = discount < 0;
  let quantityFormat = type === "fuel" ? formatVolume(quantity ?? 0) : formatDecimal(quantity, 2);

  return {
    product: (
      <>
        <Text className={styles.content}>{name ?? "--"}</Text>
      </>
    ),
    pumpNumber: (
      <>
        <Text className={styles.content}>
          {type === "fuel" ? formatPumpNumber(pumpNumber.split(",")[0]) : "--"}
        </Text>
      </>
    ),
    quantity: (
      <>
        <Text className={styles.content}>{quantityFormat}</Text>
      </>
    ),
    amount: (
      <>
        <Text className={styles.content}>{formatAmount(totalAmount)}</Text>
      </>
    ),
    discount: (
      <>
        <Text className={hasDiscount ? styles.negative : styles.content}>
          {`${hasDiscount ? "-" : ""}${formatAmount(discount)}`}
        </Text>
      </>
    ),
    finalAmountPaid: (
      <>
        <Text className={styles.content}>{formatAmount(finalAmount)}</Text>
      </>
    ),
  };
};
